export default __webpack_public_path__ + "8fb93469c7849146ec50c8cf30f35199.png";